//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 교육 및 훈련 - TBM (TRA_BASIC_01) 전용 로직
 * other 케이스에서 사용
 */

// 교육 및 훈련 - TBM 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터 (사용하지 않지만 시그니처 통일을 위해 유지)
  dispatch,
  setLoading,
  rowData1, // 전체 리스트
  searchRef
) => {
  setLoading(true);

  let tableData = [];

  try {
    if (!rowData1 || rowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }

    // 검색 연월 추출 (currentYear, month 사용)
    const currentYear = searchRef?.current?.currentYear;
    const currentMonth = searchRef?.current?.month;
    let year = '';
    let month = '';

    if (currentYear && currentMonth) {
      year = currentYear.toString();
      month = currentMonth.toString();
    } else {
      // 날짜가 없으면 현재 연월 사용
      const now = dayjs();
      year = now.format('YYYY');
      month = now.format('MM');
    }

    // 일자 포맷팅 함수 (YYYY-MM-DD)
    const FormatDate = (dateValue) => {
      if (!dateValue) return '';

      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    };

    // 시간 포맷팅 함수 (HH:mm)
    const FormatTime = (dateValue) => {
      if (!dateValue) return '';

      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${hours}:${minutes}`;
    };

    // 실시 시간(분) 포맷팅 함수 (초를 분으로 변환)
    const FormatDuration = (seconds) => {
      if (!seconds || seconds === 0) return '0분';

      const totalMinutes = Math.floor(Number(seconds) / 60);
      if (totalMinutes <= 0) return '0분';

      const hours = Math.floor(totalMinutes / 60);
      const remainMin = totalMinutes % 60;

      let result = '';
      if (hours > 0) result += `${hours}시간 `;
      if (remainMin > 0) result += `${remainMin}분`;
      return result.trim();
    };

    // tableData에 rowData1을 포맷팅하여 매핑
    tableData = rowData1.map((row) => ({
      ...row,
      TBM_DATE: FormatDate(row.TBM_DATE),
      TBM_START_DATE: FormatTime(row.TBM_START_DATE),
      TBM_END_DATE: FormatTime(row.TBM_END_DATE),
      TBM_ADD_DATE: FormatDuration(row.TBM_ADD_DATE),
    }));

    const printData = {
      FileName: 'TRA_BASIC_01',
      HeaderData: JSON.stringify({
        YEAR: year,
        MONTH: month,
      }),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};
